import script from "./BuyerSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerSelector.vue?vue&type=script&setup=true&lang=js"

import "./BuyerSelector.vue?vue&type=style&index=0&id=56d85910&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d85910"]])

export default __exports__